import Contact from './Contact';
import Profile from './Profile';
import ThematicAreas from './ThematicAreas';
import Version from './Version';

const UpdateFlow = ({
  userlogin,
  formDataUser,
  formDataProfesional,
  formDataEstudiante,
  formDataArea,
  logout,
  message,
  onBackToLogin,
  onClose,
  setUser,
}) => {
  const { updateContactBase } = Contact({
    userlogin,
    formDataUser,
    logout,
    onBackToLogin,
    setUser,
    message
  });

  const { syncProfessionalOrStudentUpdate } = Profile({
    userId: userlogin?.Id,
    formDataUser,
    formDataProfesional,
    formDataEstudiante,
    logout,
    message
  });

  const { syncThematicAreasUpdate } = ThematicAreas({
    userId: userlogin?.Id,
    formDataArea,
    logout,
    message
  });

  const { increaseUpdateNumber } = Version({userId: userlogin?.Id, logout, message});

  const updateAccount = async () => {
    const baseResult = await updateContactBase();
    if (baseResult?.stopped) return { stopped: true };
    const okProfile = await syncProfessionalOrStudentUpdate();
    if (okProfile === false) return { stopped: true };
    const okAreas = await syncThematicAreasUpdate();
    if (okAreas === false) return { stopped: true };
    await increaseUpdateNumber(baseResult.userUp);
    message('Usuario actualizado exitosamente', 'success');
    onClose?.();
    return {
      stopped: false,
      userUp: baseResult.userUp,
    };
  };

  return {
    updateAccount,
  };
};

export default UpdateFlow;
